import { render } from "./DialogServiceComponent.vue?vue&type=template&id=5e8c7eee&ts=true"
import script from "./DialogServiceComponent.vue?vue&type=script&lang=ts"
export * from "./DialogServiceComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__